export default function BrandLogo({ inverse = false }: { inverse?: boolean }) {
  return (
    <div className={`brand-logo${inverse ? ' brand-logo-inverse' : ''}`} aria-label="Zschimmer & Schwarz Brasil" role="img">
      <img src={`${import.meta.env.BASE_URL}assets/${inverse ? 'brand-mark-inverse.svg' : 'brand-mark.svg'}`} width="210" height="184" alt="" aria-hidden="true" />
      <span className="brand-name" aria-hidden="true">Zschimmer &amp; Schwarz</span>
      <span className="brand-country" aria-hidden="true">Brasil</span>
    </div>
  );
}

